import React, { Component } from "react";
import Select from "react-select";
import "./styles.css";

const commonWidth = "250px";

export default class ReactSelect extends Component {
  styles = {
    menu: (provided, state) => ({
      ...provided,
      display:
        this.props.isLoading || this.props.options.length === 0
          ? "none"
          : "flex",
      width: `calc(${commonWidth} - 25px)`,
      maxHeight: "120px",
      zIndex: 10,
      backgroundColor: "#fff",
      borderRadius: "6px",
      boxShadow: "0px 2px 6px rgba(0, 0, 64, 0.15)",
    }),
    option: (provided, state) => ({
      ...provided,
      display: "flex",
      width: `calc(${commonWidth} - 27px)`,
      padding: "8px",
      fontSize: "13px",
      fontWeight: "500",
      backgroundColor: state.isSelected || state.isFocused ? "#000040" : "#fff",
      color: state.isSelected || state.isFocused ? "#fff" : "#000040",
      cursor: "pointer",
      transition: "background 0.3s ease-in-out",
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      maxHeight: "34px",
      overflowY: "auto",
      padding: "2px 8px",
    }),
    control: (provided, state) => ({
      ...provided,
      display: "flex",
      width: commonWidth,
      height: "40px",
      border: "1px solid #000040",
      borderRadius: "6px",
      padding: "2px 8px",
      fontSize: "14px",
      fontWeight: "500",
      cursor: "pointer",
      background: "#fff",
      transition: "all 0.3s ease-in-out",
      boxShadow: state.isFocused ? "0 0 4px rgba(0, 0, 64, 0.2)" : "none",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      width: commonWidth,
      color: "#000040",
      fontWeight: "400",
      fontSize: "14px",
    }),
    placeholder: (provided, state) => ({
      ...provided,
      color: "gray",
      fontSize: "14px",
      fontWeight: "400",
    }),
  };

  render() {
    return (
      <div
        style={{
          width: commonWidth,
          height: "34px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <label
          style={{
            color: "#000040",
            textTransform: "uppercase",
            display: "inline-block",
            fontWeight: "600",
            fontSize: "11px",
            padding: "2px 8px",
            letterSpacing: "0.5px",
          }}
        >
          {this.props.label}
        </label>
        <Select
          classNamePrefix="react-select"
          styles={{
            ...this.styles,
            menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensures dropdown is on top
          }}
          value={this.props.value}
          placeholder={this.props.placeholder}
          inputValue={this.props.inputValue}
          onInputChange={this.props.onInputChange}
          options={this.props.options}
          onChange={(e) => {
            this.props.onChange(
              e,
              this.props.stateFilterName,
              this.props.stateEditName
            );
          }}
          isLoading={this.props.isLoading || false}
          closeMenuOnSelect={this.props.closeMenuOnSelect || false}
          isMulti={this.props.isMulti || false}
          menuPortalTarget={document.body} // Moves dropdown outside modal
          theme={(theme) => ({
            ...theme,
            colors: {
              ...theme.colors,
              primary: "#000040",
              primary75: "#000040",
              primary50: "#000040",
              primary25: "#000040",
            },
          })}
        />
      </div>
    );
  }
}
